import { getFAEOrderDetail } from '@/api/technical';
import React, { useCallback, useEffect, useState } from 'react';
import { formListLeft, formListRight } from '../../SubmitOrder/config';
import { Spin } from 'antd';
import { changeSourceUrl } from '@/utils/common';


interface DetailListProps {
  // Define your props here
  orderDetail: any
}

const prefix = 'fae-order-detail';


const orderList = [
  {
    id: 'list',
    children: [formListLeft.map(item => {
      return {
        label: item.label,
        value: item.name
      }
    }
    ), formListRight.map(item => {
      return {
        label: item.label,
        value: item.name
      }
    }
    )]
  },

];

const orderDesList = [
  {
    label: '工单概述',
    value: 'title',
    isRichText: false
  },
  {
    label: '工单描述',
    value: 'description',
    isRichText: true
  }

]

const DetailList: React.FC<DetailListProps> = (props) => {
  const { orderDetail } = props;


  return (

      <div className={`${prefix}-content common-list-card`}>
        <div className={`${prefix}-content-title title`}>工单详情</div>
        {
          orderList.map((item, index) => {
            return (
              <div className={`${prefix}-content-list list-row margin-bottom-16`} key={item.id}>
                {
                  item.children && item.children.map((list: any, i) => {
                    return (
                      <div className={`${prefix}-content-list `} key={item.id + '-' + i}>
                        {
                          list.map((content: any, t: any) => {
                            return (
                              <div className={`${prefix}-content-list-item common-list-card-content`} key={item.id + '-' + i + '-' + content.value}>
                                <div className={`${prefix}-content-list-item-label label`}>{content.label}:</div>
                                <div className={`${prefix}-content-list-item-value`}>{orderDetail?.[content.value] || '--'}</div>
                              </div>
                            )
                          })
                        }
                      </div>
                    )
                  })
                }
              </div>
            )
          })
        }
        {
          orderDesList.map((item, index) => {
            return <div className="list-row margin-bottom-16" key={item.value}>
              <div className={`${prefix}-content-list-item common-list-card-content`} >
                <div className={`${prefix}-content-list-item-label label`}>{item.label}:</div>
                {
                  !orderDetail ? '--' :
                    item.isRichText ?
                      <div className={`${prefix}-content-list-item-value rich-text-box`} dangerouslySetInnerHTML={{ __html: orderDetail?.[item.value] }}></div>
                      :
                      <div className={`${prefix}-content-list-item-value`}>{orderDetail?.[item.value] || '--'}</div>
                }
              </div>
            </div>
          })
        }
        {
          orderDetail ? <div className="list-row ">
          <div className={`${prefix}-content-list-item common-list-card-content`} >
            <div className={`${prefix}-content-list-item-label label`}>{'附件'}:</div>
            {
               orderDetail?.['fileList']?.length==0 ? '暂无' :
                <div className={`${prefix}-content-list-item-value attachment-list`}>
                  {
                    orderDetail?.['fileList']?.map((item: any) => {
                      return <div className='hover-underline' key={item.id}>
                        <a
                          href={changeSourceUrl(item.url)}
                          
                          download={item.name}
                          target="_self"
                          rel="noreferrer">
                          {
                            item.name
                          }
                        </a>
                      </div>
                    })}
                </div>
            }
          </div>
        </div>:null
        }

      </div>


  );
};

export default React.memo(DetailList);
